<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <a-card size="small" class="card dashboard-card">
                <a-row :gutter="8">
                    <a-col>
                        <a-input-search
                            v-model="searchstr"
                            placeholder="搜索帖子"
                            enter-button @search="search()"
                        />
                    </a-col>
                </a-row>
            </a-card>
            <a-card size="small" class="card thread-card">
                <router-view />
            </a-card>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import axios from 'axios';
import Result from './Result.vue';

export default {
    data: () => ({
        searchstr: "",
    }),
    async created() {
        this.searchstr = this.$route.query.q;
    },
    methods: {
        search() {
            this.$router.push({
                query: {
                    q: this.searchstr, p: 1,
                }
            }).catch(() => {
                
            });
        },
    },
    components: {
        MainHeader, Footer,
        Result,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.dashboard-card {
    transition: none;
    @media screen and (min-width: 560px) {
        width: 560px;
    }
    @media screen and (max-width: 559px) {
        width: 100%;
        margin-top: 0;
    }
}
.thread-card {
    transition: none;
    @media screen and (min-width: 1000px) {
        width: 98%;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
</style>
